import { render, staticRenderFns } from "./Committemember.vue?vue&type=template&id=10aa1cf6"
import script from "./Committemember.vue?vue&type=script&lang=js"
export * from "./Committemember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports